/* unplugin-vue-components disabled */import script from "./UserSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSelector.vue?vue&type=script&setup=true&lang=ts"

import "./UserSelector.vue?vue&type=style&index=0&id=4f70e0fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f70e0fb"]])

export default __exports__